<template>
    <div>
      <div style="height: 100vh;max-height:100vh;">
        <img style="width: 100%" src="./aidocbg.jpg" alt="" />
        <a-button
          type="primary"
          @click="$router.push({name:'aidoclogin'})"
          style="
            position: relative;
            bottom: 100px;
            left: 50%;
            height: 50px;
            width: 120px;
            font-size: 20px;
          "
          >查询档案</a-button
        >
      </div>
      <div class="footer">
        <h2>Copyright 2023 中国自动化学会智慧教育专业委员会 普及工作委员会</h2>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    name: "AidocIndex",
    data() {
      return {
        currdatetime: "",
      };
    },
    created() {
      this.currdatetime = new Date().getTime();
    },
    mounted() {
      let that = this;
      setInterval(function () {
        that.hide53kf();
      }, 500);
    },
    methods: {
      hide53kf() {
        let kfdom = document.getElementById("icon_module");
        if (kfdom) {
          kfdom.style.display = "none";
        }
      },
    },
  };
  </script>
  
  <style lang="less" scoped>
  .bg-pannel {
    img {
      width: 100%;
    }
  }
  .footer {
    text-align: center;
    bottom: 0;
    position: absolute;
    margin-top: 32px;
    width: 100%;
    height: 32px;
  }
  </style>